import { Modal } from "@shopify/polaris";
import React, { useCallback } from "react";
import { useChannelTeamCtx } from "../context";
import { useToastContext } from "../../shared/ToastContext";
import { DELETE_CHANNEL_TEAM } from "../../../graphql/mutations/channel-team";
import useTimeout from "../../../hooks/useTimeout";
import { arrInvalid, handleError } from "../../../helper";
import { useMutation } from "@apollo/react-hooks";

export default function ChannelTeamDelete({ open, onClose, ids }) {
    const { refetch } = useChannelTeamCtx();
    const { toggleToast, setNotify } = useToastContext();

    const [setDelay] = useTimeout();
    const [deleteChannelTeam, { loading }] = useMutation(DELETE_CHANNEL_TEAM, {
        onCompleted: () => {
            setNotify({ msg: "Delete Channel Team successfully", err: false });

            onClose();
            setDelay(() => {
                refetch && refetch();
            }, 1500);
        },
        onError: (err) => {
            setNotify({ msg: handleError(err?.toString()), err: true });
        },
    });

    const handleSubmit = useCallback(() => {
        if (arrInvalid(ids)) return;

        toggleToast && toggleToast(true);
        setNotify && setNotify({ msg: null, err: false });

        deleteChannelTeam({
            variables: {
                ids,
            },
        });
    }, [ids, deleteChannelTeam, toggleToast, setNotify]);

    return (
        <Modal
            open={open}
            onClose={onClose}
            title="Delete Channel Team"
            sectioned
            secondaryActions={[{ content: "Cancel", onAction: onClose }]}
            primaryAction={{
                content: "Submit",
                onAction: handleSubmit,
                loading,
            }}
        >
            <p>Are you sure to delete this Channel Team?</p>
        </Modal>
    );
}
